<template>
  <el-dialog
    class="teacher-editor"
    :visible="teacherEditorVisible"
    @close="closeEditor"
    width="960px"
  >
    <el-form
      :model="teacherForm"
      :rules="rules"
      ref="teacherForm"
      label-width="100px"
      class="teacher-ruleForm"
    >
      <el-form-item label="層級" prop="school_level">
        <el-radio-group v-model="teacherForm.school_level">
          <el-radio-button label="elementary-school">國小</el-radio-button>
          <el-radio-button label="junior-high-school">國中</el-radio-button>
          <el-radio-button label="high-school">高中</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="科目" prop="subject">
        <el-radio-group class="subject-radio" v-model="teacherForm.subject">
          <el-radio-button
            v-for="subject in subjects"
            :key="subject.label"
            :label="subject.label"
            >{{ subject.text }}</el-radio-button
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="姓名" placeholder="姓名" prop="name">
        <el-input class="name-input" v-model="teacherForm.name"></el-input>
      </el-form-item>
      <el-form-item label="照片" prop="photo">
        <el-upload
          class="teacher-photo-uploader"
          accept="image/*"
          :action="actionURL"
          :headers="headers"
          :show-file-list="false"
          :on-success="handleTeacherPhotoSuccess"
          :before-upload="beforePhotoUpload"
          :on-error="handleError"
        >
          <el-avatar
            v-if="teacherForm.photo"
            class="teacher-photo"
            :src="teacherForm.photo"
          ></el-avatar>
          <i v-else class="el-icon-plus teacher-photo-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="簡介" prop="resume">
        <el-input
          class="resume-input"
          type="textarea"
          placeholder="簡介"
          :autosize="{ minRows: 8 }"
          v-model="teacherForm.resume"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-for="(comment, index) in teacherForm.comments"
        :label="'學生評價' + (index + 1)"
        :key="comment.id"
        :prop="'comments.' + index + '.comment'"
        :rules="{
          required: true,
          message: '請輸入評價',
          trigger: 'blur',
        }"
      >
        <div class="comment-item">
          <el-upload
            class="comment-photo-uploader"
            accept="image/*"
            :action="actionURL"
            :headers="headers"
            :show-file-list="false"
            :on-success="
              (res, file) => {
                return handleCommentPhotoSuccess(res, index);
              }
            "
            :before-upload="beforePhotoUpload"
            :on-error="handleError"
          >
            <el-avatar
              v-if="comment.photo"
              class="comment-photo"
              :src="comment.photo"
            ></el-avatar>
            <i v-else class="el-icon-plus comment-photo-uploader-icon"></i>
          </el-upload>
          <el-input
            class="comment-input"
            type="textarea"
            placeholder="評價"
            :autosize="{ minRows: 5 }"
            v-model="comment.comment"
          ></el-input>
        </div>
        <el-button
          type="success"
          v-if="index == teacherForm.comments.length - 1"
          @click.prevent="addComment"
          >新增+</el-button
        >
        <el-button
          @click.prevent="removeComment(comment)"
          v-if="teacherForm.comments.length > 1"
          >删除</el-button
        >
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEditor">取 消</el-button>
      <el-button type="primary" @click="confirm">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['teacherEditorVisible', 'teacherForm', 'isCreate'],
  data() {
    return {
      rules: {
        school_level: [
          { required: true, message: '請選擇層級', trigger: 'blur' },
        ],
        subject: [{ required: true, message: '請選擇科目', trigger: 'blur' }],
        name: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
        photo: [
          { required: true, message: '請上傳教師大頭照', trigger: 'blur' },
        ],
        resume: [{ required: true, message: '請輸入簡介', trigger: 'blur' }],
      },
    };
  },
  computed: {
    actionURL: () => process.env.VUE_APP_API_UPLOAD,
    headers() {
      return {
        Authorization: localStorage.getItem('token'),
      };
    },
    subjects() {
      switch (this.teacherForm.school_level) {
        case 'elementary-school':
          return [
            {
              label: 'chinese',
              text: '國文',
            },
            {
              label: 'math',
              text: '數學',
            },
            {
              label: 'english',
              text: '英文',
            },
            {
              label: 'natural',
              text: '自然',
            },
            {
              label: 'society',
              text: '社會',
            },
          ];
        case 'junior-high-school':
          return [
            {
              label: 'chinese',
              text: '國文',
            },
            {
              label: 'math',
              text: '數學',
            },
            {
              label: 'english',
              text: '英文',
            },
            {
              label: 'natural',
              text: '自然',
            },
            {
              label: 'society',
              text: '社會',
            },
          ];
        case 'high-school':
          return [
            {
              label: 'chinese',
              text: '國文',
            },
            {
              label: 'math',
              text: '數學',
            },
            {
              label: 'english',
              text: '英文',
            },
            {
              label: 'physical',
              text: '物理',
            },
            { label: 'chemistry', text: '化學' },
            { label: 'biology', text: '生物' },
            {
              label: 'history',
              text: '歷史',
            },
            {
              label: 'geography',
              text: '地理',
            },
            {
              label: 'citizen',
              text: '公民',
            },
          ];
        default:
          return [];
      }
    },
  },
  methods: {
    handleTeacherPhotoSuccess(res) {
      this.teacherForm.photo = res.Location;
    },
    handleCommentPhotoSuccess(res, index) {
      this.teacherForm.comments[index].photo = res.Location;
    },
    beforePhotoUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('圖片大小不能超過 5MB!');
      }
      return isLt5M;
    },
    handleError(e) {
      let result = JSON.parse(e.message || '{}');
      this.loading = false;
      this.$message.error(`圖片上傳失敗 ${result.message || ''}`);
    },
    confirm() {
      this.$refs['teacherForm'].validate(async (valid) => {
        if (valid) {
          this.$emit('saveTeacher', this.teacherForm);
        } else {
          return false;
        }
      });
    },
    closeEditor() {
      this.$emit('update:teacherEditorVisible', false);
    },
    addComment() {
      this.teacherForm.comments.push({
        comment: '',
        photo: '/static-img/avatar.png',
        id: Date.now(),
      });
    },
    removeComment(item) {
      var index = this.teacherForm.comments.indexOf(item);
      if (index !== -1) {
        this.teacherForm.comments.splice(index, 1);
      }
    },
  },
  created() {},
  mounted() {},
  components: {},
};
</script>

<style lang="scss">
.teacher-editor {
  .teacher-ruleForm {
    padding-right: 30px;
  }

  .name-input {
    width: 200px;
  }

  .teacher-photo {
    width: 150px;
    height: 150px;
  }

  .comment-photo {
    width: 100px;
    height: 100px;
  }

  .teacher-photo-uploader .el-upload {
    width: 150px;
    height: 150px;
    border: 1px dashed #d9d9d9;
    border-radius: 100%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .teacher-photo-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .teacher-photo-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }

  .comment-photo-uploader .el-upload {
    width: 100px;
    height: 100px;
    border: 1px dashed #d9d9d9;
    border-radius: 100%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .comment-photo-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .comment-photo-uploader-icon {
    font-size: 20px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .comment-input {
    margin-bottom: 5px;
  }
}
</style>
